import { api } from '@/lib/api'

export type SourceMappingRow = {
  dotPath: string
  targetKind: 'CONTRACT_FIELD' | 'PRODUCT_FIELD'
  fieldCode: string
  productCode: string | null
}

const base = (cfg: string, src: string) => `/api/configurations/${cfg}/sources/${src}/field-mappings`

export async function listSourceMappings(cfg: string, src: string): Promise<SourceMappingRow[]> {
  const r = await api.get<SourceMappingRow[]>(base(cfg, src))
  return r.data
}

export async function replaceSourceMappings(
  cfg: string,
  src: string,
  rows: SourceMappingRow[],
): Promise<SourceMappingRow[]> {
  const r = await api.put<SourceMappingRow[]>(base(cfg, src), rows)
  return r.data
}
